import * as React from 'react';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { isEmpty } from 'ramda';
import { useSelector } from 'react-redux';

import { PricesDynamicsContainer } from './containers/PricesDynamicsContainer';
import { SalesDynamicsContainer } from './containers/SalesDynamicsContainer';
import { TabsContainer } from './containers/TabsContainer';
import { trackRealtyValuationInView } from './tracking';
import { RealtyValuation } from '../../components/RealtyValuation';
import { selectRealtyValuationData } from '../../selectors/realtyValuation/';

export function RealtyValuationContainer() {
  const realtyValuation = useSelector(selectRealtyValuationData);

  if (!realtyValuation || isEmpty(realtyValuation)) {
    return null;
  }

  const { promo, lastUpdatedText } = realtyValuation;

  return (
    <ActionAfterViewObserver callback={trackRealtyValuationInView} wrapper={false}>
      <RealtyValuation
        title="Цены и спрос"
        promoText={promo}
        lastUpdatedAt={lastUpdatedText}
        content={
          <TabsContainer pricesDynamics={<PricesDynamicsContainer />} salesDynamics={<SalesDynamicsContainer />} />
        }
      />
    </ActionAfterViewObserver>
  );
}
